import { createApp } from 'vue';
// import "./style.css";
import DpcVirtualPhotoBooth from './dpc-virtual-photo-booth.vue';
import VueKonva from 'vue-konva';

if (document.querySelector('#virtual-photo-booth')) {
  const app = createApp(DpcVirtualPhotoBooth);
  app.use(VueKonva);
  app.mount('#virtual-photo-booth');
}
